// extracted by mini-css-extract-plugin
export default {"table":"Table_table__5e9JG","row":"Table_row__ZONCb","sortCell":"Table_sortCell__LA2hx","cell":"Table_cell__8tArH","head":"Table_head__t2txW","body":"Table_body__jEVI-"};